import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';

export const agenteRoutes: RouteConfig[] = [
  {
    path: '/agente/dashboard',
    element: <Components.AgenteDashboardPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/propiedades',
    element: <Components.AgentePropertiesPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/propiedades/crear',
    element: <Components.AgenteCreatePropertyPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // GH#2413 — el detalle existía (AgentePropertyDetailPage) pero no estaba registrado: «Ver» terminaba en 404.
  // NO se registra `/agente/propiedades/:id/editar`: AgenteEditPropertyTemplate precarga precio y área en 0 con la
  // propiedad real (lee el modelo anidado viejo) y abriría una vía de guardar ceros sobre datos reales (GH#2409).
  {
    path: '/agente/propiedades/:id',
    element: <Components.AgentePropertyDetailPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/clientes',
    element: <Components.SharedClientsPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/clientes/agregar',
    element: <Components.CreateClientPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/clientes/nuevo',
    element: <Components.CreateClientPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/clientes/papelera',
    element: <Components.ClientsTrashPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/cotizaciones',
    element: <Components.AgenteQuotesPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/cotizaciones/crear',
    element: <Components.AgenteCreateQuotePage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/cotizaciones/:id/editar',
    element: <Components.AgenteEditQuotePage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/citas/agregar',
    element: <Components.AgenteAddAppointmentPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/citas',
    element: <Components.AgenteAppointmentsPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/ventas',
    element: <Components.AgenteSalesPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/ventas/registrar',
    element: <Components.AgenteRegisterSalePage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/reportes',
    element: <Components.AgenteReportsPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agente/configuracion',
    element: <Components.AgenteSettingsPage />,
    roles: ['AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
];
